import { createAsyncThunk } from "@reduxjs/toolkit";

import apiRequest from "../../../services/api";

export const fetchFiles = createAsyncThunk("/file_vault", async (body) => {
  let query = "";
  if (body.page) {
    query = query + `page=${body.page}&`;
  }
  if (body.page_size) {
    query = query + `page_size=${body.page_size}&`;
  }
  if (body.apiStartDate) {
    query = query + `from_date=${body.apiStartDate}&`;
  }
  if (body.apiEndDate) {
    query = query + `to_date=${body.apiEndDate}&`;
  }
  if (body.search) {
    query = query + `search=${body.search}`;
  }

  const verifyDetails = await apiRequest.get(`v1/file_vault/?${query}`, {
    headers: { organization: body.userOrganization.org_id },
  });
  return verifyDetails.data;
});

export const uploadNewFile = createAsyncThunk(
  "/file_vault/create",
  async (body, { rejectWithValue }) => {
    try {
      const uploadVaultFile = await apiRequest.post(
        `v1/file_vault/`,
        body.newFileFormData,
        {
          headers: {
            organization: body.userOrganization.org_id,
            "content-type": "multipart/form-data",
          },
        }
      );
      return uploadVaultFile.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteUploadedFile = createAsyncThunk(
  "/file_vault/delete",
  async (body) => {
    const verifyDetails = await apiRequest.delete(
      `v1/file_vault/?id=${body.file_id}`,
      { headers: { organization: body.userOrganization?.org_id } }
    );
    return verifyDetails.data;
  }
);
